<script>
  import HeroBanner from "./components/banner/HeroBanner.svelte";
  import Nyctography from "./components/nyctograpy/Nyctography.svelte";
  import SiteFooter from "./components/footer/SiteFooter.svelte";
</script>

<main>
  <HeroBanner />
  <Nyctography />
  <SiteFooter />
</main>
